import { useEffect } from "react";
import { io, Socket } from "socket.io-client";

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_URL as string;

// Dedicated chat socket, kept separate from the notifications socket
// (UseSocketNotifications) so that the messaging feature never interferes
// with the existing app-wide notification behavior. Singleton + listener
// count so multiple chat components share one connection and it is torn
// down only when the messaging screen fully unmounts.
let socket: Socket | null = null;
let listenersCount = 0;

const useChatSocket = (userId: string) => {
  useEffect(() => {
    if (!userId) return;

    if (!socket) {
      socket = io(SOCKET_SERVER_URL, { query: { receiverId: userId } });
    }

    listenersCount++;

    return () => {
      listenersCount--;
      if (listenersCount === 0) {
        socket?.disconnect();
        socket = null;
      }
    };
  }, [userId]);

  return socket;
};

export { socket };

export default useChatSocket;
